import React from 'react'
import classes from "./Third.module.scss"
import img1 from "../../../assets/img/costcall/3/1.png"
const Third = () => {
    return (
        <div className={[classes.third, "pt pb"].join(" ")}>
            <div className={[classes.thirdBody, ""].join(" ")}>
                <div className="container">
                    <div className={[classes.thirdRow, ""].join(" ")}>
                        <div className={[classes.thirdRowLeft, ""].join(" ")}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={[classes.thirdRowRight, ""].join(" ")}>
                            <div className={[classes.thirdRowRightTitle, "font-40"].join(" ")}>
                                Глобальная сеть серверов Bomber VPN: мощный<span> инструмент для вашей безопасности и свободы </span>
                                <div>в интернете </div>
                            </div>
                            <div className={[classes.thirdRowRightDecor, "decor"].join(" ")}>
                                <span></span><span></span><span></span>
                            </div>
                            <div className={[classes.thirdRowRightBottom, ""].join(" ")}>
                                <p className='font-22'>
                                    Широкая сеть серверов VPN обеспечивает надежное и быстрое соединение в любой точке мира. Наш сервис располагает более 3000 серверами, охватывающими 160+ стран по всему миру. Это позволяет нашим пользователям выбирать из различных локаций для подключения, обеспечивая максимальную скорость и стабильность в любой ситуации.
                                </p>
                                <p className='font-22'>Независимо от того, где вы находитесь, наши серверы гарантируют доступ к контенту и услугам без географических ограничений.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default Third